import { getFunctionSignature, } from './getFunctionSignature.js';
export const getEventSignature = (fn) => {
    return getFunctionSignature(fn);
};
//# sourceMappingURL=getEventSignature.js.map